import React, {
  Component
} from 'react';
import {
  Link
} from 'react-router';
import {
  connect
} from 'react-redux';
import {
  bindActionCreators
} from 'redux';
import {
  changeColor,
  clearDraw
} from '../../../actions/ts_overlay_actions.js';
import {
  updateModal
} from '../../../actions/modal.js';
import {
  updateCanvas
} from '../../../actions/ts_canvas_actions.js';
import {
  Button,
  Modal,
  Grid,
  Row,
  Col,
  Clearfix,
  ButtonToolbar,
  DropdownButton,
  MenuItem,
  ButtonGroup,
  Dropdown,
  Accordion,
  Panel,
  PanelGroup
} from 'react-bootstrap';
import Shapes from './shapes.js';
import Letters from './letters.js';
import Numbers from './numbers.js';
import Colors from '../colors.js';
var Stamps = React.createClass({
  getInitialState: function() {

              return {
                  display:'shapes',
              }
      },

  renderModal(content) {
    var modalContent;
    if (content == 'shapes') {
      this.setState({ display: content})
      //modalContent = <Login/>;
    }
    if (content == 'numbers') {
      this.setState({ display: content})
        //modalContent = <Register/>;
    }
    if (content == 'letters') {
      this.setState({ display: content})
        //modalContent = <Register/>;
    }
  },

  stampSelected(stamp) {
    var {
      dispatch,
      overlay
    } = this.props;
    dispatch(clearDraw(overlay.color, overlay.color1, overlay.color2));
    dispatch(updateModal(false, null));
  },

  displayLogic(content) {
    if (content == 'shapes') {
      //modalContent = <Login/>;
      return (<Shapes/>)
    }
    if (content == 'numbers') {
        //modalContent = <Register/>;
        return (<Numbers/>)
    }
    if (content == 'letters') {
        //modalContent = <Register/>;
        return (<Letters/>)
    }
  },

  render() {
    var {
      overlay,
      map,
      currentUser,
      stamp
    } = this.props;
    var content = this.state.display;
    var shapesStyle;
    var numbersStyle;
    var lettersStyle;
    if (content == 'shapes')
    {
      shapesStyle = "buttonActive";
      numbersStyle = "buttonNotActive";
      lettersStyle = "buttonNotActive";
    }
    if (content == 'letters')
    {
      shapesStyle = "buttonNotActive";
      numbersStyle = "buttonNotActive";
      lettersStyle = "buttonActive";
    }
    if (content == 'numbers')
    {
      shapesStyle = "buttonNotActive";
      numbersStyle = "buttonActive";
      lettersStyle = "buttonNotActive";
    }
    var img = stamp.stamp;
    var cellStyle= "fa-2x stamp";
    if(overlay.color == 'blue'){
      cellStyle ="fa-2x icon-blue stamp";
    }
    if(overlay.color == 'red'){
        cellStyle ="fa-2x icon-red stamp";
    }
    return (
      <div className="stampsBG">
      <div className = "form-group" >
      <span className="headerText">Stamps</span>
      </div>
      <div className = "form-group stampsColor" >
      <Colors/><span className={cellStyle}>{img}</span>
      </div>
      <br/>
      <div className = "form-group" >
      <label className={shapesStyle} onClick={(event) => {this.renderModal('shapes');}}>Shapes</label>
      <label className="dividerStamps"> | </label>
      <label className={lettersStyle}  onClick={(event) => {this.renderModal('letters');}}> Letters</label>
      <label className="dividerStamps"> | </label>
      <label className={numbersStyle}  onClick={(event) => {this.renderModal('numbers');}}> Numbers</label>
      {/*<label className="dividerStamps"> | </label>
      <label disabled className="buttonNotActive"  onClick={(event) => {this.renderModal('weapons');}}><i>Weapons</i></label>
      <label className="dividerStamps"> | </label>
      <label disabled className="buttonNotActive"  onClick={(event) => {this.renderModal('phrases');}}><i>Phrases</i></label>*/}
      </div>
      {this.displayLogic(content)}

 </div>
    );
  }
});


module.exports = connect((state) => {
  return {
    overlay: state.overlay,
    map: state.map,
    currentUser: state.currentUser,
    stamp: state.stamp
  }
})(Stamps);



// WEBPACK FOOTER //
// ./src/app/components/tools/stamps/index.js